'use strict';

function handleAddressSuggestionFocus(e) {
    var focusableItems = e.target.closest('.address-suggestions').querySelectorAll('[tabindex="0"]');
    var firstItem = focusableItems[0];
    var lastItem = focusableItems[focusableItems.length - 1];
    var currentIndex;

    if (e.which === 9) {
        if (document.activeElement === lastItem && !e.shiftKey) {
            e.preventDefault();
            firstItem.focus();
        } if (document.activeElement === firstItem && e.shiftKey) {
            e.preventDefault();
            lastItem.focus();
        }
    } else if (e.which === 40) {
        e.preventDefault();
        if (document.activeElement === lastItem) {
            firstItem.focus();
        } else {
            currentIndex = Array.from(focusableItems).indexOf(document.activeElement);
            focusableItems[currentIndex + 1].focus();
        }
    } else if (e.which === 38) {
        e.preventDefault();
        if (document.activeElement === firstItem) {
            lastItem.focus();
        } else {
            currentIndex = Array.from(focusableItems).indexOf(document.activeElement);
            focusableItems[currentIndex - 1].focus();
        }
    } else if (e.which === 27) {
        e.stopImmediatePropagation();
    }
}

function handleAddressInputArrow() {
    document.querySelectorAll('.address-suggestions').forEach((elem) => {
        elem.previousElementSibling.querySelectorAll('input').forEach((input) => {
            input.addEventListener('keydown', (e) => {
                if (e.which === 40) {
                    e.preventDefault();
                    var firstItem = e.target.closest('fieldset, form').querySelector('.address-suggestions [tabindex="0"]');
                    if (firstItem) {
                        firstItem.focus();
                    }
                }
            });
        });
    });
}

module.exports = {
    handleAddressSuggestionFocus,
    handleAddressInputArrow
};
